/*
 * Public API Surface of ngx-lib/date
 */
export * from './date.module';
export * from './date.component';
